import { action } from "typesafe-actions";
import {
  DischargeTypes,
  DischargeViewItem,
  DischargeSubmitPayload,
  DischargeReasonItem,
} from "./types";

export const loadDischargeRequest = (external_attendance_id: string) =>
  action(DischargeTypes.LOAD_REQUEST, { external_attendance_id });

export const loadDischargeSuccess = (data: DischargeViewItem) =>
  action(DischargeTypes.LOAD_SUCCESS, data);

export const loadDischargeFailure = () =>
  action(DischargeTypes.LOAD_FAILURE);

export const loadReasonsRequest = (external_attendance_id: string) =>
  action(DischargeTypes.LOAD_REASONS_REQUEST, { external_attendance_id });

export const loadReasonsSuccess = (data: DischargeReasonItem[]) =>
  action(DischargeTypes.LOAD_REASONS_SUCCESS, data);

export const loadReasonsFailure = () =>
  action(DischargeTypes.LOAD_REASONS_FAILURE);

export const submitDischargeRequest = (body: DischargeSubmitPayload) =>
  action(DischargeTypes.SUBMIT_REQUEST, body);

export const submitDischargeSuccess = (response: any) =>
  action(DischargeTypes.SUBMIT_SUCCESS, response);

export const submitDischargeFailure = () =>
  action(DischargeTypes.SUBMIT_FAILURE);
